import { Injectable } from "@angular/core";

/**
 * A small simple url-state service which can hold the last entered URL.
 * The normal StateService can't be used because it will clear all it's states on a logout-event.
 */
@Injectable({
    providedIn: 'root'
})
export class LastUrlService {

    lastUrl: LoginUrl;

    constructor() {
    }

    public setLastUrl(lastUrl: LoginUrl) {
        this.lastUrl = lastUrl;
    }

    public getLastUrl(): LoginUrl {
        return this.lastUrl;
    }

    public clearLastUrl() {
        this.lastUrl = undefined;
    }
}

export class LoginUrl {
    path: string;
    parms: any;
}
